import interpolate from '@/utils/interpolate';
import { getValue } from '@/utils/dataTools';
import Vue, { PluginObject, VueConstructor } from 'vue';

export function enrichVars<T = any>(input: T, map: Record<string, any>): T {
    const _input = JSON.parse(JSON.stringify(input || {}));

    const readVar = (varName: any) => {
        if (/({{)/.test(varName)) {
            return interpolate(varName, map);
        } else if (/\$/.test(varName)) {
            return getValue(map, [].concat(varName.split('.')));
        } else {
            return varName;
        }
    };

    const walk = (step: any): any => {
        if (Array.isArray(step)) {
            return step.map((value) =>
                typeof value === 'object' ? walk(value) : readVar(value)
            );
        } else if (typeof step === 'object' && step !== null) {
            return Object.entries(step).reduce(
                (prev, [key, value]) =>
                    typeof value === 'object'
                        ? { ...prev, [key]: walk(value) }
                        : { ...prev, [key]: readVar(value) },
                {}
            );
        } else {
            console.error('input must be an object, received type is', typeof step);
        }
    };

    return walk(_input);
}

export const EnrichVarsPlugin: PluginObject<Vue> = {
    install(Vue: VueConstructor) {
        Vue.prototype.$enrichVars = enrichVars;
    },
};
